import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ImageList,
  ImageListItem,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { useParams } from "react-router-dom";

const EditBlogImage = ({ openView, setOpenView, data }) => {
  const { id } = useParams();
  const [oldImage, setOldImageImages] = useState(data);
  const [newPhotos, setNewPhotos] = useState([]);
  const [deleteImage, setDeleteImages] = useState([]);

  const handleRemovePhoto = (fileToRemove) => {
    const updatedData = oldImage.filter((file) => file !== fileToRemove);
    setDeleteImages((prevDeletedImages) => [
      ...prevDeletedImages,
      fileToRemove,
    ]);
    setOldImageImages(updatedData);
  };

  const handleRemoveNewPhoto = (fileToRemove) => {
    const updatedData = newPhotos.filter((file) => file !== fileToRemove);
    setNewPhotos(updatedData);
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      console.log("Accepted Files:", acceptedFiles);

      setNewPhotos((prevFiles) => [
        ...prevFiles,
        ...acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        ),
      ]);
    },
  });

  useEffect(
    () => () => {
      newPhotos.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [newPhotos]
  );

  const handleUploadImage = async () => {
    const formData = new FormData();
    newPhotos.forEach((file) => {
      formData.append(`blog_images`, file);
    });
    formData.append(`deleteImages`, JSON.stringify([...deleteImage]));
    try {
      const config = {
        withCredentials: true,
        headers: {
          withCredentials: true,
        },
      };

      await axios.post(
        `${process.env.REACT_APP_URL}/blog/update-blog-images?id=${id}`,
        formData,
        config
      );
      console.log("success", "Banquet updated successfully.");

      setOpenView(false);
    } catch (error) {
      console.log("error", error.response.data.message);
    }
  };

  return (
    <Dialog
      open={openView}
      onClose={() => setOpenView(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
    >
      <DialogTitle
        style={{ backgroundColor: "#7352C7", color: "white" }}
        id="alert-dialog-title"
      >
        Selected Images ({oldImage.length})
      </DialogTitle>

      <DialogContent
        headerSx={{
          borderBottom: 1,
          borderColor: "divider",
        }}
        sx={{ mb: 3.75 }}
      >
        <ImageListItem>
          <div
            {...getRootProps({ className: "dropzone" })}
            style={{ marginTop: "10px", width: "118px" }}
          >
            <input {...getInputProps()} />
            <Button size="small" variant="contained">
              Add Photo
            </Button>
          </div>
        </ImageListItem>
        <ImageList
          sx={{ width: "100%", maxHeight: 250 }}
          cols={3}
          rowHeight={110}
        >
          {oldImage?.map((file) => (
            <ImageListItem key={file}>
              <HighlightOffIcon
                style={{
                  position: "absolute",
                  top: 5,
                  right: 5,
                  cursor: "pointer",
                  color: "red",
                }}
                onClick={() => handleRemovePhoto(file)}
              />
              <img
                src={`${process.env.REACT_APP_BACKEND_IMAGE_PATH}/blog/${file}`}
                alt=""
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </ImageListItem>
          ))}
          {newPhotos?.map((file) => (
            <ImageListItem key={file.name}>
              <HighlightOffIcon
                style={{
                  position: "absolute",
                  top: 5,
                  right: 5,
                  cursor: "pointer",
                  color: "red",
                }}
                onClick={() => handleRemoveNewPhoto(file)}
              />
              <img
                src={file.preview}
                alt=""
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          type="submit"
          variant="contained"
          onClick={() => handleUploadImage(newPhotos)}
        >
          update images
        </Button>
        <Button
          size="small"
          variant="outlined"
          onClick={() => setOpenView(false)}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default EditBlogImage;
